var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carbonIndex"},[_c('h2',{staticClass:"sr-only"},[_vm._v("碳匯專區")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }